import { Component, OnInit } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { Alert } from '../../services/alerts.service';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    standalone: false
})
export class AlertsComponent implements OnInit {

  constructor(public alertsService: AlertsService) { }

  ngOnInit() {
  }

  close(alert: Alert) {
    this.alertsService.remove(alert);
  }
}
